import type { LinkHref } from "@octopusdeploy/portal-routes";
import { isLocationObject, resolvePathWithSpaceId } from "@octopusdeploy/portal-routes";
import type { Location } from "react-router-dom";
import { useParams, Navigate } from "react-router-dom";
import { isUrl } from "~/components/Navigation/InternalLink/isUrl";
import { useUrlResolver } from "~/components/Navigation/useUrlResolver";
interface InternalRedirectProps {
    to: Partial<Location> | LinkHref;
    push?: boolean;
}
function InternalRedirect({ to, push }: InternalRedirectProps) {
    const urlResolver = useUrlResolver();
    const params = useParams<{
        spaceId: string | undefined;
    }>();
    const resolvedPath = isUrl(to) ? urlResolver.resolve(to) : resolvePathWithSpaceId(to, params.spaceId);
    const state = !isUrl(to) && isLocationObject(to) ? to.state : undefined;
    /* eslint-disable react/forbid-elements */
    return <Navigate to={resolvedPath} replace={!push} state={state}/>;
}
export default InternalRedirect;
